export const scrollToTop = (daley = 100) => {
  setTimeout(() => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: -400,
        behavior: 'smooth',
      });
    });
  }, daley);
};
